module.exports = __webpack_public_path__ + "img/pdf-icon.4122f416.svg";